module.exports = __webpack_public_path__ + "static/media/degauss.ac33a2aa.png";